import { combineReducers } from 'redux';

import artists from './artist';
import auth from './auth'
import accounts from './account'

export default combineReducers({ artists, auth, accounts });